'use strict';

import "./stylesheets/main.scss";

import Simplebar from 'simplebar';
import { init } from './game/main';

// TODO: Enable this to go straight to the waves
window.DEBUG_VISIBLE = false
window.DEBUG_DEVICE_ORIENTATION = false
window.DEBUG_WATER_TEST = false
window.DEBUG_DEACTIVATE_NO_ACTIVITY = true
window.DEBUG_GAME_TIME = 0 // 0 for default
window.DEBUG_SKIP_TO_GAME = false
window.DEBUG_SKIP_LOADER = false
window.DEBUG_SHOW_OUTRO_ON_START = false
window.DEBUG_FORCE_SOUND_OFF = false
window.DEBUG_SHOW_FORM_ON_START = false

window.isWEBOneParty = true;
window.isWEB = true;

/**
 * URL PARAMETERS
 */
var getParams = function (url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
}

var DEFAULT_LANG = 'en'
var initParams = function() {
  // lang = fr | en | ...  // if no lang, show overlay language
  // retail = sdfsdf
  // form = 1 // to show form with 3 optins
  // form = 2 // to show form with 1 optin and a specific intro
  // share = 1 // to show share

  const _params = getParams(window.location.href)
  console.log(`////////// PARAMS`, _params);

  // Retail
  if (_params.retail) {
    window.retail = _params.retail.toLowerCase();
  }

  let _bt_subscribe_url = ''
  let _bt_discover_url = ''
  if (_params.lang) {
    let _langISO = _params.lang.toLowerCase()
    let _lang = ''
    let _country = ''
    switch(_langISO) {
      case 'fr-fr':
        _lang = 'fr';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/fr-fr/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/fr-fr/parfum-le-male-le-parfum'
        break;
      case 'en-gb':
        _lang = 'en';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/en-gb/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/en-gb/fragrance-le-male-le-parfum'
        break;
        case 'en-us':
        _lang = 'en';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/en-us/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/en-us/fragrance-le-male-le-parfum'
        break;
      case 'es-es':
        _lang = 'es';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/es-es/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/es-es/perfume-le-male-le-parfum'
        break;
      case 'es-cl':
        _lang = 'es';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/es-cl/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/es-cl/perfume-le-male-le-parfum'
        break;
      case 'es-ar':
        _lang = 'es';
        // _country = 'ar'; // Specify the country for special traduction
        _country = _lang; // Specify the country for special traduction
        if (window.retail === 'juleriaque') _country = 'ar-juleriaque'
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/es-ar/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/es-ar/perfume-le-male-le-parfum'
        break;
      case 'es-mx':
        _lang = 'es';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/es-mx/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/es-mx/perfume-le-male-le-parfum'
        break;
      case 'it-it':
        _lang = 'it';
        _country = _lang;
        _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/it-it/spectacles/be-the-captain/?newsletter=open'
        _bt_discover_url = 'https://www.jeanpaulgaultier.com/it-it/profumo-le-male-le-parfum'
        break;
      case 'pt-br':
          _lang = 'pt';
          _country = _lang;
          _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/pt-br/spectacles/be-the-captain/?newsletter=open'
          _bt_discover_url = 'https://www.jeanpaulgaultier.com/pt-br/perfume-le-male-le-parfum'
        break;
      case 'nl-nl':
          _lang = 'nl';
          _country = _lang;
          _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/nl-nl/spectacles/be-the-captain/?newsletter=open'
          _bt_discover_url = 'https://www.jeanpaulgaultier.com/nl-nl/parfum-le-male-le-parfum'
        break;
      case 'de-de':
          _lang = 'de';
          _country = _lang;
          _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/de-de/spectacles/be-the-captain/?newsletter=open'
          _bt_discover_url = 'https://www.jeanpaulgaultier.com/de-de/parfum-le-male-le-parfum'
        break;
      default:
        _lang = DEFAULT_LANG;
        _country = _lang;
    }
    window.lang = _lang;
    window.country = _country;
    window.langISO = _langISO;
    window.SUBSCRIBE_URL = _bt_subscribe_url
    window.DISCOVER_URL = _bt_discover_url
  } else {
    // If no lang param, show overlay language
    // console.log(`SIMPLE BAR`, document.querySelector('[data-simplebar]'));

    new Simplebar(document.querySelector('[data-simplebar]'));
    document.querySelector('.overlay-language').style.display = 'flex';
    /* window.lang = DEFAULT_LANG
    window.langISO = 'en-us'
    _bt_subscribe_url = 'https://www.jeanpaulgaultier.com/en-us/spectacles/be-the-captain/?newsletter=open'
    _bt_discover_url = 'https://www.jeanpaulgaultier.com/en-us/fragrance-le-male-le-parfum'
    window.SUBSCRIBE_URL = _bt_subscribe_url
    window.DISCOVER_URL = _bt_discover_url */
  }

  // Internal form
  if (_params.form) {
    window._sf1 = _params.form === 1 || _params.form === '1'; // Internal form subscribe
    window._sf2 = _params.form === 2 || _params.form === '2'; // External form
  }

  // Share
  // Only for standalone version, otherwise need to call a js function in the window top container to open the popup
  if (_params.share) {
    window._share = _params.share === 1 || _params.share === '1'
  }
}

/**
 * TRADUCTIONS
 */
var initTrads = function() {
  // Textes or Nodes
  const aTrads = document.querySelectorAll(`.trad-${window.country}`)
  for (let i = 0, nb = aTrads.length; i < nb; ++i) {
    aTrads[i].style.display = 'inherit';
  }

  // Images
  const aImgs = document.querySelectorAll(`[data-trad-src]`)
  let elImg
  console.log(`Images to translate`, aImgs)
  for (let i = 0, nb = aImgs.length; i < nb; ++i) {
    elImg = aImgs[i]
    elImg.src = elImg.dataset.tradSrc.replace(/_LANG/, `_${window.country}`)
  }
}

/**
 * PLATFORM AND DEVICE
 */
var initDeviceDetection = function() {
  console.log('Platform', navigator.platform);
  console.log('User agent', navigator.userAgent);

  var sUserAgent = navigator.userAgent.toString().toLowerCase();
  var elDebugNavigator = document.getElementById('debug-navigator');
  elDebugNavigator.innerHTML = sUserAgent;
  elDebugNavigator.innerHTML += '<br /> Platform : ' + navigator.platform;

  // var iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  var iOS = /ipad|iphone|ipod/.test(sUserAgent);
  if (iOS) {
    document.body.classList.add('ios')
    elDebugNavigator.innerHTML += '<br /> ios';
  }

  // var iPhone = navigator.platform && /iPhone/.test(navigator.platform);
  var iPhone = /iphone/.test(sUserAgent);
  if (iPhone) {
    document.body.classList.add('iphone')
    elDebugNavigator.innerHTML += '<br /> iphone';
  }

  // var iPad = navigator.platform && /iPad/.test(navigator.platform);
  var iPad = /ipad/.test(sUserAgent);
  if (iPad) {
    document.body.classList.add('ipad')
    elDebugNavigator.innerHTML += '<br /> ipad';
  }

  var isMac = navigator.platform && navigator.platform.toUpperCase().indexOf('MAC')>=0;
  if (isMac) {
    document.body.classList.add('mac')
    elDebugNavigator.innerHTML += '<br /> mac';
  }

  var isFirefox = /mozilla/.test(sUserAgent);
  if (isFirefox) {
    document.body.classList.add('firefox')
    elDebugNavigator.innerHTML += '<br /> firefox';
  }

  var isSafari = /safari/.test(sUserAgent);
  if (isSafari) {
    document.body.classList.add('safari')
    elDebugNavigator.innerHTML += '<br /> safari';
  }

  // var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i)?true:false;
  // var isIOS = navigator.platform.match(/(iPhone|iPod|iPad)/i)?true:false;
}

/**
 * LOAD
 */
window.addEventListener('load', function() {
  console.log(`####### Main window loaded ! WEB`);
  initParams();
  initTrads();
  init();
});

window.addEventListener('DOMContentLoaded', function() {
  console.log('Main window DOMContentLoaded !');
  initDeviceDetection();
});

var elDebugError = document.querySelector('#debug-error')
window.addEventListener('error', (msg, url, lineNo, columnNo, error) => {
  elDebugError.innerHTML += msg + '<br/>';
  console.error(msg);
})
